/* eslint-disable camelcase */
/* eslint-disable react/display-name */
/**
 * @file TFGDeteriorationView.jsx
 * @author Daniel Aguirre
 * @description TFGDeterioration View Page
 */

// Dependencies
import React, { useEffect, useState } from 'react';
import { useTranslation } from 'react-i18next';
import PropTypes from 'prop-types';
import DashboardCard from 'components/DashboardCard';
import { useHistory } from 'react-router';

import DashboardProgress from 'components/Charts/DashboardProgress';
import styleGuideColors from 'commons/styleGuideColors';

/**
 * TFGDeterioration View
 * @param { Object } dashboardStaffActions - DashboardStaff Actions.
 * @return { Node } React node.
 */

function TFGDeteriorationView({ dashboardStaffActions, clinicId }) {
  const { t: translate } = useTranslation();
  const history = useHistory();
  const [chartData, setChartData] = useState([]);

  const { getTFGDeterioration } = dashboardStaffActions;

  const getProgressData = (key, color, total) => {
    return {
      label: translate(`commons.${key.deterioro}`),
      value: ((key.cantidad * 100) / total).toFixed(3).slice(0, -1),
      color,
      cantidad: key.cantidad,
      deterioroSeleccionado: key.deterioro
    };
  };

  const onGetData = (_, resp) => {
    if (resp?.data) {
      const yes = resp.data.find(({ deterioro }) => deterioro === 'Si');
      const no = resp.data.find(({ deterioro }) => deterioro === 'No');
      const total = (yes?.cantidad || 0) + (no?.cantidad || 0);

      const data = {
        progress: yes
          ? getProgressData(yes, styleGuideColors.alertError, total)
          : {},
        max: no
          ? getProgressData(no, styleGuideColors.baxterBrandTeal, total)
          : {}
      };
      setChartData(data);
    }
  };

  useEffect(() => {
    getTFGDeterioration({ clinicId }, onGetData);
  }, [clinicId, translate]);

  const handleDetailClick = (section) => {
    const { cantidad: totalItems, deterioroSeleccionado } = chartData[section];
    history.push(
      `/main/dashboard-detail/tfg-deterioration/${deterioroSeleccionado}/${totalItems}`
    );
  };

  return (
    <DashboardCard id="F16" loading={chartData.length === 0}>
      <DashboardProgress
        title={translate('dashboardStaff.TFGDeterioration')}
        max={chartData.max}
        progress={chartData.progress}
        onDetailClick={handleDetailClick}
      />
    </DashboardCard>
  );
}

/**
 * Component definition of proptypes.
 */
TFGDeteriorationView.propTypes = {
  dashboardStaffActions: PropTypes.shape({
    getTFGDeterioration: PropTypes.func.isRequired
  }),
  clinicId: PropTypes.any
};

export default TFGDeteriorationView;
